module.exports = __webpack_public_path__ + "static/media/ic_card_kyc_default.e4727071.svg";